export default __webpack_public_path__ + "static/media/video-unmute.44f16042.svg";